import {
  GET_STATS,
  GET_STATS_SUCCESS,
  GET_STATS_NEXT_PAGE_SUCCESS,
  GET_STATS_ERROR,
  GET_LIVE_ATTENDEES,
  GET_LIVE_ATTENDEES_SUCCESS,
  GET_LIVE_ATTENDEES_ERROR,
  GET_RECORDED_VIEWS,
  GET_RECORDED_VIEWS_SUCCESS,
  GET_RECORDED_VIEWS_ERROR,
  GET_WEBINAR_DATA,
  GET_WEBINAR_DATA_SUCCESS,
  GET_WEBINAR_DATA_ERROR,
} from "../constants/actions";

export const getStats = (meta) => ({
  type: GET_STATS,
  payload: { meta },
});

export const getStatsSuccess = (stats, pages) => ({
  type: GET_STATS_SUCCESS,
  payload: { stats, pages },
});

export const getStatsNextPageSuccess = (stats) => ({
  type: GET_STATS_NEXT_PAGE_SUCCESS,
  payload: { stats },
});

export const getStatsError = (error) => ({
  type: GET_STATS_ERROR,
  payload: { error },
});

export const getLiveAttendees = (workshop) => ({
  type: GET_LIVE_ATTENDEES,
  payload: { workshop },
});

export const getLiveAttendeesSuccess = (users) => ({
  type: GET_LIVE_ATTENDEES_SUCCESS,
  payload: { users },
});

export const getLiveAttendeesError = (error) => ({
  type: GET_LIVE_ATTENDEES_ERROR,
  payload: { error },
});

export const getRecordedViews = (workshop) => ({
  type: GET_RECORDED_VIEWS,
  payload: { workshop },
});

export const getRecordedViewsSuccess = (users) => ({
  type: GET_RECORDED_VIEWS_SUCCESS,
  payload: { users },
});

export const getRecordedViewsError = (error) => ({
  type: GET_RECORDED_VIEWS_ERROR,
  payload: { error },
});

export const getWebinarData = (webinar_id) => ({
  type: GET_WEBINAR_DATA,
  payload: { webinar_id },
});

export const getWebinarDataSuccess = (webinar) => ({
  type: GET_WEBINAR_DATA_SUCCESS,
  payload: { webinar },
});

export const getWebinarDataError = (error) => ({
  type: GET_WEBINAR_DATA_ERROR,
  payload: { error },
});



// WEBPACK FOOTER //
// ./src/actions/stats.js